import { render } from "./Todolist.vue?vue&type=template&id=7ad894b8"
import script from "./Todolist.vue?vue&type=script&lang=js"
export * from "./Todolist.vue?vue&type=script&lang=js"
script.render = render

export default script